import Axios from 'axios';
import { SelfTimingEvent, Entry, EventEntryList } from '../models/Event';
import SelfTimingBackendMock from './SelfTimingBackendMock';
import Auth from '@aws-amplify/auth';
import {CognitoUserSession} from 'amazon-cognito-identity-js';

const _backend : string = "https://dkfh7qtt0m.execute-api.eu-north-1.amazonaws.com/prod/";
class SelfTimingBackend {
    getEvents = async () : Promise<SelfTimingEvent[]> => {
       // let user = await Auth.currentAuthenticatedUser();
        let hdrs = {} as any;
       /* if (user != null)
        {
            let sess = await Auth.currentSession();
            hdrs = {
                headers:{Authorization:sess.getAccessToken().getJwtToken()}
            };
        }*/
        return Axios.get(_backend + "events/",hdrs).then(res => {
            return res.data as SelfTimingEvent[];
        });
    }

    getMyEvents = () : Promise<SelfTimingEvent[]> => {
        return Auth.currentSession().then((sess : CognitoUserSession) => {
            return Axios.get(_backend + "admin/events/",
               {
                   headers:{Authorization:sess.getAccessToken().getJwtToken()}
               }).then(res => {
                   return res.data as SelfTimingEvent[];
               }).catch((err) => {
                   console.log(err);
                   return null
               });
           });
    }

    getEvent = async (id: string) : Promise<SelfTimingEvent> => {
        let hdrs = {} as any;
        try {
            let sess = await Auth.currentSession();
            
            if (sess != null)
            {
                hdrs = {
                    headers:{Authorization:sess.getAccessToken().getJwtToken()}
                };
            }
        }
        catch {}

        return Axios.get(_backend + "events/" + id,hdrs).then(res => {
            return res.data as SelfTimingEvent;
        });
    }

    getEntriesForEvent = (eventid: string) : Promise<EventEntryList> => {
        return Axios.get(_backend + "events/" + eventid + "/entries").then(res => {
            return res.data as EventEntryList;
        });
    }

    saveEntry = (eventid: string, className: string, entry : Entry) : Promise<boolean> => {
        return Axios.put(_backend + "events/" + eventid + "/" + className + "/entries",entry).then(res => {
            return true;
        }).catch((err) => {
            console.log(err);
            return false;
        });
    }
    saveEvent = (event:SelfTimingEvent) : Promise<SelfTimingEvent> => {
        return Auth.currentSession().then((sess : CognitoUserSession) => {
         return Axios.post(_backend + "admin/events/" + event.Id,event,
            {
                headers:{Authorization:sess.getAccessToken().getJwtToken()}
            }).then(res => {
                return res.data as SelfTimingEvent;
            }).catch((err) => {
                console.log(err);
                return null;
            });
        });
    }
    addEvent = (event:SelfTimingEvent) : Promise<SelfTimingEvent> => {
        return Auth.currentSession().then((sess : CognitoUserSession) => {
         return Axios.put(_backend + "admin/events/",event,
            {
                headers:{Authorization:sess.getAccessToken().getJwtToken()}
            }).then(res => {
                return res.data as SelfTimingEvent;
            }).catch((err) => {
                console.log(err);
                return null;
            });
        });
    }
}

export default SelfTimingBackend;